import React from "react";
import Alert from "@mui/material/Alert";

export const GenericMessage = (props: any) => {
  /********Website Noftifaction mgs*********/
  //console.log(props, "--00--");
  const data = props.data ? props.data : "";
  return data && data.display === true ? (
    <Alert
      severity="warning"
      sx={{
        justifyContent: "center",
        padding: 0,
      }}
    >
      {data.message}
    </Alert>
  ) : null;
};
